import { render, staticRenderFns } from "./tables.vue?vue&type=template&id=03a5aee1&scoped=true"
import script from "./tables.vue?vue&type=script&lang=ts"
export * from "./tables.vue?vue&type=script&lang=ts"
import style0 from "./tables.vue?vue&type=style&index=0&id=03a5aee1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a5aee1",
  null
  
)

export default component.exports